import React, { Component } from 'react';

class DocumentsComponent extends Component {
    render () {

        const { documents } = this.props;

        if (!documents || !documents.length) {
            return null;
        }

        const getDocumentExtension = (filepath) => {
            const parts = filepath.split('.');
            const ext = parts[parts.length - 1];
            return ext;
        }

        const documentsBlock = documents.map((doc, i) => {

            let documentClass = '';
            switch (getDocumentExtension(doc.file_path)) {
                case 'doc':
                case 'docx':
                    documentClass = 'fa fa-file-word-o';
                    break;
                case 'xls':
                case 'xlsx':
                case 'xlt':
                    documentClass = 'fa fa-file-excel-o';
                    break;
                case 'ppt':
                case 'ppt':
                case 'pps':
                    documentClass = 'fa fa-file-powerpoint-o';
                    break;
                case 'pdf':
                    documentClass = 'fa fa-file-pdf-o';
                    break;
                case 'jpeg':
                case 'bmp':
                case 'png':
                case 'jpg':
                case 'gif':
                case 'tiff':
                    documentClass = 'fa fa-file-image-o';
                    break;
                default:
                    documentClass = 'fa fa-file-o';
                    break;
            }

            return (
                <div className="documents-item" key={i}>
                    <p className="documents-item-title">
                        {doc.type}
                    </p>
                    <a href={doc.file_path} target='_blank'>
                        <i className={documentClass}></i>
                    </a>
                </div>
            )
        });

        return (
            <div  className="details-container">
                <h2 className="section-header">Flyers and Documents</h2>
            <div id="documents" className="documents-component">
                <div className="documents-component-content">
                    {documentsBlock}
                </div>
            </div>
            </div>
        )
    }
}

export default DocumentsComponent;